export default "__VITE_ASSET__b620c868__"